console.log('reports.js loaded!');

$(document).on("click", ".month-row", function () {
  if (!$("body.reports.index").length) {
    return;
  }

  if ($(this).hasClass("closed")) {
    $(this).siblings(".files-list").removeClass("hidden");
    $(this).children("i").addClass("fa-minus").removeClass("fa-plus");
  } else {
    $(this).siblings(".files-list").addClass("hidden");
    $(this).children("i").addClass("fa-plus").removeClass("fa-minus");
  }

  $(this).toggleClass("closed");
});

$(document).on("click", "#open_all", function () {
  if (!$("body.reports.index").length) {
    return;
  }

  $(".month-row.closed").each(function () {
    $(this).siblings(".files-list").removeClass("hidden");
    $(this).children("i").addClass("fa-minus").removeClass("fa-plus");
    $(this).removeClass("closed");
  });
});

$(document).on("click", "#close_all", function () {
  $(".month-row")
    .not($(".closed"))
    .each(function () {
      $(this).siblings(".files-list").addClass("hidden");
      $(this).children("i").addClass("fa-plus").removeClass("fa-minus");
      $(this).addClass("closed");
    });
});

// FOIA Notice Modal
$(document).on('turbo:load turbolinks:load ready', function () {
  console.log('Page loaded, checking for reports page');
  const path = window.location.pathname.split("/");
  const whitelist = ["reports", "sisense", "powerbi"];

  function findCommonElement(array1, array2) {
    for (let i = 0; i < array1.length; i++) {
      for (let j = 0; j < array2.length; j++) {
        if (array1[i] === array2[j]) {
          return true;
        }
      }
    }
    return false;
  }
  
  if (!findCommonElement(whitelist, path)) {
    return;
  }

  if (localStorage.getItem("accepted-foia-notice") === null) {
    showModal();
  } else {
    const timeUserLastAgreed = parseInt(
      localStorage.getItem("accepted-foia-notice")
    );
    const today = Date.now();
    const twoDaysAgo = today - (1000 * 60 * 60 * 24 * 2);
    
    if (timeUserLastAgreed < twoDaysAgo) {
      console.log("clear storage & show modal");
      localStorage.removeItem("accepted-foia-notice");
      showModal();
    }
  }
});

function showModal() {
  // Remove any existing overlay
  $("#overlay").remove();
  
  $("body").append(
    '<div class="modal-backdrop" style="background-color: rgba(0, 0, 0, 0.3)" id="overlay"></div>'
  );
  $("#overlay").append(createModal());
  
  attachModalHandlers();
}

function createModal() {
  const modal = $("<div>", {
    id: "foia-notice",
    role: "dialog",
    "aria-labelledby": "myModalLabel",
  });

  const modalHeader = $("<div>", {
    class: "modal-header",
  });

  const headerTitle = $("<h2>", {
    class: "modal-title",
    text: "Action Item",
  });

  const headerClose = $("<button>", {
    type: "button",
    class: "close",
    text: "×",
    style: "margin-left: auto;",
  });

  modalHeader.append(headerTitle);
  modalHeader.append(headerClose);

  const body = $("<p>", {
    text: "VRSA encourages you to confer with your entity's attorney and/or FOIA officer prior to downloading data.",
  });

  const foiaCheckboxLabel = $("<label>", {
    text: "I understand that by downloading a report, I may be creating a record that is subject to FOIA.",
    for: "foia-checkbox",
  });

  const foiaCheckbox = $("<input>", {
    type: "checkbox",
    id: "foia-checkbox",
    style: "margin: 4px 10px",
  });

  const foiaCheckboxDiv = $("<div>", {
    id: "checkbox-div",
  });

  foiaCheckboxDiv.append(foiaCheckbox);
  foiaCheckboxDiv.append(foiaCheckboxLabel);
  body.append(foiaCheckboxDiv);

  const cancel = $("<button>", {
    id: "cancel",
    class: "btn btn-default",
    text: "Cancel",
    style: "margin-right: 10px; width: 110px",
  });

  const accept = $("<button>", {
    id: "accept",
    class: "btn btn-primary",
    text: "Continue",
    disabled: true,
    style: "margin-left: 10px; width: 110px",
  });

  const modalBody = $("<div>", {
    class: "modal-body",
    style: "padding: 20px",
  });

  const footer = $("<div>");
  footer.append(cancel);
  footer.append(accept);
  modalBody.append(body);
  modalBody.append(footer);
  modal.append(modalHeader);
  modal.append(modalBody);

  // Styles
  modalHeader.css({
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
    display: "flex",
  });

  body.css({
    display: "flex",
    flexDirection: "column",
  });

  footer.css({
    display: "flex",
    justifyContent: "center",
    padding: "0 20px",
  });

  foiaCheckboxDiv.css({
    display: "flex",
    flexDirection: "row",
    padding: "10px 10px 10px 0px",
  });

  modal.css({
    opacity: "1",
    display: "block",
    position: "fixed",
    top: "30%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "450px",
    minHeight: "310px",
    backgroundColor: "white",
    border: "1px solid #ccc",
    borderRadius: "4px",
    boxShadow: "0 0 10px #ccc",
  });

  return modal;
}

function attachModalHandlers() {
  // Checkbox handler
  $(document).on("change", "#foia-checkbox", function() {
    $("#accept").prop("disabled", !this.checked);
  });

  // Close button handler
  $(document).on("click", "#foia-notice .close", function() {
    $("#overlay").remove();
    window.history.back();
  });

  // Cancel button handler
  $(document).on("click", "#cancel", function() {
    $("#overlay").remove();
    window.history.back();
  });

  // Accept button handler
  $(document).on("click", "#accept", function() {
    localStorage.setItem('accepted-foia-notice', Date.now());
    $("#overlay").remove();
  });
}

// Logout handler
$(document).on("click", "#logout", function () {
  localStorage.removeItem("accepted-foia-notice");
});